<template>
  <div id="slide-6" class="slide pt-37.5 px-23.5 relative flex flex-col h-screen gap-12.5">
    <div>
      <div class="flex justify-between">
        <img src="@/assets/images/talk.svg" class="w-9 h-9" alt="" />
        <p
            class="text-center uppercase fz-10 font-medium"
            style="color: rgba(110, 117, 141, 1); letter-spacing: 0.3rem"
        >
          {{ text.agencyName }}
        </p>
      </div>
      <p class="fz-201 font-medium text-justify text mt-5">{{ text.text }}</p>
    </div>
    <a href="#mobile-start" class="agency flex items-center" @click="setRoute('agency')">
      <div class="plus relative w-12.5 h-12.5 mr-5 rounded-full" style="background:#fff;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
      </div>
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">{{ text.agency }}</p>

    </a>
    <div class="flex gap-17.5 justify-end">
      <div class=" w-55 h-55 overflow-hidden">
        <img
            src="@/assets/images/slide_5/max_photo.png"
            class="h-55"
            style="transform: scaleX(1.5) translateX(14%)"
            alt=""
        />
      </div>

      <div class="flex flex-col gap-5">
        <img
            src="@/assets/images/wiki.svg"
            class="w-14 h-14 p-4 rounded-full border-2"
            style="border-color: rgba(151, 163, 203, 0.3)"
            alt=""
        />
        <img
            src="@/assets/images/fb.svg"
            class="w-14 h-14 p-4 rounded-full border-2"
            style="border-color: rgba(151, 163, 203, 0.3)"
            alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide6",
  data() {
    return {
      maxHover: false,
    };
  },
  computed: {
    text() {
      return require("@/assets/text/main/slide5/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
  methods:{
    ...mapMutations(['setRoute'])
  }
};
</script>

<style lang="scss" scoped>
.text {
  text-indent: 11.25rem;
}
</style>
